"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionContext = void 0;
const Axon = require("@jlekie/axon");
class ActionContext {
    constructor(metadata) {
        this.metadata = metadata || new Axon.VolatileTransportMetadata();
        this.tracers = [];
    }
    static fromMetadata(source) {
        const metadata = Axon.VolatileTransportMetadata.fromMetadata(source);
        return new this(metadata);
    }
    branchActivity(activity) {
        const metadata = Axon.VolatileTransportMetadata.fromMetadata(this.metadata);
        metadata.addOrSet('aid', Buffer.from(activity.id, 'utf8'));
        return ActionContext.fromMetadata(metadata);
    }
}
exports.ActionContext = ActionContext;
